// extracted by mini-css-extract-plugin
export default {"designExamples":"DesignExamples_designExamples__TcwVH","designExamplesRow":"DesignExamples_designExamplesRow__-vFmr"};